import React, {useState} from "react";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import CalendarHeader from "../Views/CalendarHeader";
import CalendarBody from "../Views/CalendarBody";
import EventPageViewController from "../../../Common/Views/Modals/EventViewModal/EventPageViewController";
import CalendarEvent from "../../../Common/Models/CalendarEvent";

const Container = styled(Grid)`
  height: calc(100% - 58px);
  margin-bottom: 60px;
`;


const CalendarViewController = () => {
    const [selectedEvent, selectEvent] = useState<any>();
    const [currentPage, setCurrentPage] = useState<number>(0);

    const onClick = (item: CalendarEvent) => selectEvent(item);
    const onClose = () => selectEvent(undefined);

    const onCalendarChange = (event: any, index: number) => {
        setCurrentPage(index);
    };

    return (
       <Container container>
           <CalendarHeader page={currentPage} onChange={onCalendarChange} />
           <CalendarBody page={currentPage} onClick={onClick} />
           <EventPageViewController
               open={!!selectedEvent}
               calendarEvent={selectedEvent}
               onDismiss={onClose}
           />

       </Container>
    );
};

export default CalendarViewController;